import React, { forwardRef } from 'react';

function Textarea(props, ref) {
  return <textarea {...props} ref={ref} />;
}

export default forwardRef(Textarea);
